<div class="col-span-12 flex flex-col gap-(--spacing-layout-l)">
  <div class="flex justify-between items-center">
    <span class="text-heading-small text-primaryText">
      {{ 'RM.DASHBOARD.LIVE_DEALS.TITLE' | translate }}
    </span>
    <div class="flex items-center gap-3">
      @if (showViewAll()) {
        <app-button
          [label]="('RM.DASHBOARD.OPEN_ACTIONS.VIEW_ALL' | translate) + ' (' + dealsTotal() + ')'"
          variant="text"
          endIcon="/icons/arrow-right.svg"
          (onClick)="onViewAll()"
        />
      }
    </div>
  </div>

  <app-paginated-grid
    [items]="dealsItems()"
    [loading]="loading()"
    [emptyMessage]="getEmptyMessage()"
    [totalRecords]="dealsTotal()"
    [first]="dealsFirst()"
    [rows]="dealsPageSize()"
    [rowsPerPageOptions]="[2, 4, 10]"
    [trackByKey]="'id'"
    [skeletonCount]="2"
    [paginator]="false"
    (pageChange)="onPageChange($event)"
  >
    <ng-template let-item>
      <app-card rootClass="border border-primaryBorder h-full" bodyClass="h-full" contentClass="h-full flex flex-col">
        <div class="flex flex-col flex-1">
          <div class="p-5 flex justify-between items-start shrink-0">
            <div class="flex flex-col justify-center">
              <span class="text-subheading-large text-headingText">{{ item.name }}</span>
              <div class="flex items-center gap-2">
                <svg-icon [src]="getAssetClassIcon(item.assetClass)" svgClass="w-4 h-4"></svg-icon>
                <span class="text-body-large text-bodyText">
                  {{ getCategoriesFromDeal(item).join(' | ') }}
                </span>
              </div>
            </div>
            <app-tag [value]="getDealTag(item)" [severity]="getDealTagSeverity(item)" />
          </div>

          <div class="p-5 flex flex-col gap-4 pt-0 flex-1">
            <div class="flex flex-col justify-center gap-2">
              <span class="text-subheading-medium text-headingText">
                {{ getDealRemainingAllocation(item) | number: '1.0-2' }}% remaining allocation
              </span>
              <app-progress-bar [value]="getDealProgressValue(item)" />
            </div>

            <app-divider [style]="{ margin: '0px' }" />

            <div class="flex gap-2">
              <div class="flex flex-col flex-1 gap-2">
                <span class="text-subheading-medium text-headingText">Min Investment:</span>
                <app-currency-display
                  class="text-body-large text-bodyText"
                  [value]="item.minimumAmountUsd"
                  [currencyCode]="item.currency || 'USD'"
                  [compact]="true"
                />
              </div>
              <div class="flex flex-col flex-1 gap-2">
                <span class="text-subheading-medium text-headingText">Target Return:</span>
                <span class="text-body-large text-bodyText">{{ item.targetReturn }}%</span>
              </div>
              <div class="flex flex-col flex-1 gap-2">
                <span class="text-subheading-medium text-headingText">Duration:</span>
                <span class="text-body-large text-bodyText">{{ item.duration }}</span>
              </div>
            </div>

            <div class="flex flex-col gap-2">
              <span class="text-subheading-medium text-headingText">Description:</span>
              <span class="text-body-large text-bodyText">{{ item.description }}</span>
            </div>

            @if (item.sections && item.sections?.some(section => section.title === 'Why Invest?')) {
              @for (section of item.sections; track section) {
                @if (section.title === 'Why Invest?') {
                  <div class="flex flex-col gap-2 flex-1">
                    <span class="text-subheading-medium text-headingText">{{ section.title }}</span>
                    <div class="rich-text-content" [innerHTML]="section.content"></div>
                  </div>
                }
              }
            }

            <a [routerLink]="getDealDetailsLink(item)" class="w-full">
              <app-button
                [label]="'View Details'"
                [styleClass]="'w-full'"
                endIcon="/icons/eye.svg"
                variant="secondary"
              />
            </a>
          </div>
        </div>
      </app-card>
    </ng-template>
  </app-paginated-grid>
</div>
